import {Router} from "@angular/router";
import {Component} from "@angular/core";
import {ConsultationEventManager} from "app/pages/cerba/pages/alertes/consultation/consultation.eventManger";
import { ITagsWebServiceClient } from "@common/resources/resources";
import { ModalService, UserStore } from "@digicerba/common";


@Component({
  selector: 'cm-header',
  templateUrl: './header.component.html',
  host: {'class': 'header'}
})
export class HeaderComponent {

  isAdmin: boolean;
  hasAdminTag: boolean;

  constructor(private tagsWebService: ITagsWebServiceClient, userStore: UserStore, private router: Router,
              private consultationEventManager: ConsultationEventManager, private modalService :  ModalService ) {
    this.isAdmin = userStore.isAdmin();
    this.tagsWebService.getAccessAdminAuthorization().subscribe((result: boolean) => {
      this.hasAdminTag = result;
    });
  }

  isConsultation() {
    return this.router.url.indexOf("/alertes") >= 0;
  }

  marquerCommesLues() {
    this.modalService.openConfirmDialog("MODAL.NOTIFICATIONS.AS_READ.title", "MODAL.NOTIFICATIONS.AS_READ.message",
    "MODAL.NOTIFICATIONS.AS_READ.confirm", "MODAL.NOTIFICATIONS.AS_READ.cancel").onDialogClose().subscribe(() => {
      this.consultationEventManager.setmarquerCommeLu();
    }); 

  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-notifications/digicerba-notifications-web/src/angular/cerba/src/app/pages/cerba/header/header.component.ts